/* eslint-disable @typescript-eslint/no-explicit-any */
import { ProjectPaperLayout } from "app/areas/projects/components/ProjectPaperLayout";
import * as React from "react";
import SidebarLayout from "~/components/SidebarLayout/SidebarLayout";
import type { Level2PageLayoutProps } from "~/routing/pageRegistrations/Level2PageLayoutProps";
export type TabbedPaperLayoutProps = Level2PageLayoutProps & {
    tabNavigation?: React.ComponentType<any>;
    hideTabNavigation?: boolean;
    sidebar?: React.ReactNode;
};
export const TabbedPaperLayout: React.FC<TabbedPaperLayoutProps> = (props) => {
    const { tabNavigation: TabNavigationComponent, hideTabNavigation = false, disableAnimations = true, children, ...rest } = props;
    return (<ProjectPaperLayout disableAnimations={disableAnimations} {...rest}>
            {TabNavigationComponent && !hideTabNavigation && <TabNavigationComponent />}
            <SidebarLayout sideBar={props.sidebar} hideTopDivider={true}>
                {children}
            </SidebarLayout>
        </ProjectPaperLayout>);
};
TabbedPaperLayout.displayName = "TabbedPaperLayout"
TabbedPaperLayout.defaultProps = {
    fullWidth: true,
};
export default TabbedPaperLayout;
